/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Menu, Dropdown, Icon, message } from 'antd';

import USMLogoImage from 'assets/images/USMLogo.png';
import SpmsLogoImage from 'assets/images/SPMSLogo.png';
import SpmsICLogoImage from 'assets/images/SPMS_IC_Logo.png';
import SpmsCILogoImage from 'assets/images/SPMS_CI_Logo.png';
import SpmsSELogoImage from 'assets/images/SPMS_SE_Logo.png';
import SpmsMobileLogoImage from 'assets/images/SPMSMobileLogo.png';
import SpmsICMobileLogoImage from 'assets/images/SPMS_IC_MobileLogo.png';
import SpmsCIMobileLogoImage from 'assets/images/SPMS_CI_MobileLogo.png';
import SpmsSEMobileLogoImage from 'assets/images/SPMS_SE_MobileLogo.png';
import PaddedRowWrapper from 'containers/PaddedRowWrapper';
import { SPECIALISATION_TO_DETAILS } from 'globals/constants';
import { getSyncStoreUser } from 'globals/selectors';
import withSyncStoreRouterSpecialisation from 'globals/withSyncStoreRouterSpecialisation';
import { createCancellableRequestAPI, fetchCustomData } from 'utils/request';

import {
  NavBarFlexbox,
  FlexGrowPlaceholder,
  HeaderLogoImg,
  ResponsiveUSMLogoLink,
  ResponsiveSPMSMobileLogoLink,
  ResponsiveSPMSWebLogoLink,
  ResponsiveUSMLogoImg,
  ResponsiveSPMSMobileLogoImg,
  ResponsiveSPMSWebLogoImg,
  HeaderLink,
  HeaderIconLink,
  HeaderClickableWrapper,
  Line,
} from './styles';

const [
  cancellableLogoutRequestAPI,
  cancelLogoutRequestAPI,
] = createCancellableRequestAPI();

function Header({ history, specialisation }) {
  const dispatch = useDispatch();
  const user = useSelector(getSyncStoreUser);

  useEffect(() => cancelLogoutRequestAPI, []);

  const SPMSLogoImage = {
    ic: SpmsICLogoImage,
    ci: SpmsCILogoImage,
    se: SpmsSELogoImage,
    null: SpmsLogoImage,
  }[specialisation];
  const SPMSMobileLogoImage = {
    ic: SpmsICMobileLogoImage,
    ci: SpmsCIMobileLogoImage,
    se: SpmsSEMobileLogoImage,
    null: SpmsMobileLogoImage,
  }[specialisation];

  const createHandleRedirectToOtherSpecialisation = otherSpecialisation => () => {
    history.push(
      history.location.pathname.replace(
        `/${specialisation}`,
        `/${otherSpecialisation}`,
      ),
    );
    history.go(0); // Force page reload
  };
  const handleLogout = () => {
    fetchCustomData(
      cancellableLogoutRequestAPI,
      `/${specialisation}/users/logout`,
      { credentials: 'include' },
      resObject => {
        message.success('You have been successfully logged out');
        history.push(`/${specialisation}`);
        return resObject;
      },
      errorObject => {
        history.push(`/${specialisation}`);
        return errorObject;
      },
      dispatch,
    );
  };

  if (!specialisation) {
    return (
      <>
        <PaddedRowWrapper backgroundColor="headerBackground">
          <NavBarFlexbox>
            <ResponsiveUSMLogoImg src={USMLogoImage} alt="USM Logo" />
            <ResponsiveSPMSMobileLogoImg
              src={SPMSMobileLogoImage}
              alt="SPMS Mobile Logo"
            />
            <ResponsiveSPMSWebLogoImg src={SPMSLogoImage} alt="SPMS Logo" />
            <FlexGrowPlaceholder />
          </NavBarFlexbox>
        </PaddedRowWrapper>
        <Line />
      </>
    );
  }
  if (user === undefined || user === null) {
    return (
      <>
        <PaddedRowWrapper backgroundColor="headerBackground">
          <NavBarFlexbox>
            <ResponsiveUSMLogoLink to={`/${specialisation}`}>
              <HeaderLogoImg src={USMLogoImage} alt="USM Logo" />
            </ResponsiveUSMLogoLink>
            <ResponsiveSPMSMobileLogoLink to={`/${specialisation}`}>
              <HeaderLogoImg src={SPMSMobileLogoImage} alt="SPMS Mobile Logo" />
            </ResponsiveSPMSMobileLogoLink>
            <ResponsiveSPMSWebLogoLink to={`/${specialisation}`}>
              <HeaderLogoImg src={SPMSLogoImage} alt="SPMS Logo" />
            </ResponsiveSPMSWebLogoLink>
            <FlexGrowPlaceholder />
            <HeaderLink to={`/${specialisation}/users/login`}>Login</HeaderLink>
          </NavBarFlexbox>
        </PaddedRowWrapper>
        <Line />
      </>
    );
  }
  if (
    /^\/\w+\/users\/privilegedlogin$/.test(history.location.pathname) ||
    /^\/\w+\/users\/firstlogin/.test(history.location.pathname)
  ) {
    return (
      <>
        <PaddedRowWrapper backgroundColor="headerBackground">
          <NavBarFlexbox>
            <ResponsiveUSMLogoLink to={`/${specialisation}`}>
              <HeaderLogoImg src={USMLogoImage} alt="USM Logo" />
            </ResponsiveUSMLogoLink>
            <ResponsiveSPMSMobileLogoLink to={`/${specialisation}`}>
              <HeaderLogoImg src={SPMSMobileLogoImage} alt="SPMS Mobile Logo" />
            </ResponsiveSPMSMobileLogoLink>
            <ResponsiveSPMSWebLogoLink to={`/${specialisation}`}>
              <HeaderLogoImg src={SPMSLogoImage} alt="SPMS Logo" />
            </ResponsiveSPMSWebLogoLink>
          </NavBarFlexbox>
        </PaddedRowWrapper>
        <Line />
      </>
    );
  }
  return (
    <>
      <PaddedRowWrapper backgroundColor="headerBackground">
        <NavBarFlexbox>
          <ResponsiveUSMLogoLink to={`/${specialisation}`}>
            <HeaderLogoImg src={USMLogoImage} alt="USM Logo" />
          </ResponsiveUSMLogoLink>
          <ResponsiveSPMSMobileLogoLink to={`/${specialisation}`}>
            <HeaderLogoImg src={SPMSMobileLogoImage} alt="SPMS Mobile Logo" />
          </ResponsiveSPMSMobileLogoLink>
          <ResponsiveSPMSWebLogoLink to={`/${specialisation}`}>
            <HeaderLogoImg src={SPMSLogoImage} alt="SPMS Logo" />
          </ResponsiveSPMSWebLogoLink>
          <FlexGrowPlaceholder />
          <HeaderIconLink to={`/${specialisation}/${user.role}`}>
            <Icon type="dashboard" />
          </HeaderIconLink>
          <Dropdown
            trigger={['click']}
            overlay={
              <Menu>
                {['admin', 'lecturer'].includes(user.role)
                  ? Object.keys(SPECIALISATION_TO_DETAILS)
                      .filter(
                        otherSpecialisation =>
                          otherSpecialisation !== specialisation,
                      )
                      .map(otherSpecialisation => (
                        <Menu.Item
                          key={otherSpecialisation}
                          onClick={createHandleRedirectToOtherSpecialisation(
                            otherSpecialisation,
                          )}
                        >
                          Go to{' '}
                          {SPECIALISATION_TO_DETAILS[otherSpecialisation].label}
                        </Menu.Item>
                      ))
                  : null}
                <Menu.Item>
                  <Link to={`/${specialisation}/${user.role}/changepassword`}>
                    Change password
                  </Link>
                </Menu.Item>
                <Menu.Item onClick={handleLogout}>Log out</Menu.Item>
              </Menu>
            }
          >
            <HeaderClickableWrapper>
              Hi{' '}
              {user.role === 'admin'
                ? 'Admin'
                : user.role === 'coordinator'
                ? 'Coordinator'
                : user.name}
              !
              <Icon type="down" />
            </HeaderClickableWrapper>
          </Dropdown>
        </NavBarFlexbox>
      </PaddedRowWrapper>
      <Line />
    </>
  );
}

Header.propTypes = {
  history: PropTypes.object.isRequired,
  specialisation: PropTypes.string,
};
Header.defaultProps = {
  specialisation: null,
};

export default withSyncStoreRouterSpecialisation(Header, ['user']);
